import { useQuery, UseQueryOptions } from 'react-query';

import { StagedDiligenceRequestUpload, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomDiligenceRequestUploadsQuery(
	guid: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<StagedDiligenceRequestUpload[], unknown, StagedDiligenceRequestUpload[]>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomDiligenceRequests.Uploads(guid),
		() =>
			AxiosUtils.getResponseData<StagedDiligenceRequestUpload[]>(
				api.get(CerebroApiEndpoints.DataRoomDiligenceRequests.Uploads(guid))
			),
		options
	);
}
